/**
 * Text Toggle Block - Show/hide content when clicking labels
 */
(function () {
    'use strict';

    function initTextToggle() {
        document.querySelectorAll('.text-toggle').forEach((block) => {
            const labels = block.querySelectorAll('.text-toggle__labels .text-toggle__label');
            const panels = block.querySelectorAll('.text-toggle__panel');

            labels.forEach((label, index) => {
                label.addEventListener('click', () => {
                    labels.forEach((l) => {
                        l.classList.remove('is-active');
                        l.setAttribute('aria-expanded', 'false');
                    });
                    panels.forEach((p, i) => {
                        p.classList.remove('is-active');
                        p.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
                    });

                    label.classList.add('is-active');
                    label.setAttribute('aria-expanded', 'true');
                    if (panels[index]) {
                        panels[index].classList.add('is-active');
                    }
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTextToggle);
    } else {
        initTextToggle();
    }
})();
